import React from "react";
import ResetPassword from "components/ResetPassword";
import Layout from "components/common/Layout";
import { withEnhancedServerSideProps } from "helpers/withEnhancedProps";

function ResetPasswordPage() {
  return (
    <Layout>
      <div className="max-w-2xl mx-auto">
        <ResetPassword />
      </div>
    </Layout>
  );
}

export default ResetPasswordPage;

export const getServerSideProps = withEnhancedServerSideProps(async () => ({
  props: {
    allowed: ["guest", "user"], // Allow both authenticated and unauthenticated users
  },
}));
